import { WbTable, WbTableCell, WbTableHeader, WbTableRow, WbText } from '@workbench/react';
import { useTranslation } from 'react-i18next';
import './InfoPanelsTable.scss';

function InfoPanelsTable({ data, descText }) {
	const { t } = useTranslation();

	return (
		<div className="vimdt-info-table">
			<WbText size="s" className="vimdt-info-table__description">
				{descText}
			</WbText>
			{data && (
				<WbTable>
					<WbTableRow>
						<WbTableHeader>{t('vimdt.placeholders.parameter')}</WbTableHeader>
						<WbTableHeader>{t('vimdt.placeholders.description')}</WbTableHeader>
					</WbTableRow>
					{data.map((row) => (
						<WbTableRow key={row.key ?? row.type}>
							<WbTableCell>{row.type}</WbTableCell>
							<WbTableCell>{row.desc}</WbTableCell>
						</WbTableRow>
					))}
				</WbTable>
			)}
		</div>
	);
}

export default InfoPanelsTable;
